import React from 'react';
import './BottomTabBar.css';
import { HomeIcon, ProjectIcon, MineIcon, TestIcon } from './TabIcons';

/** 改为 false 可显示底部「测试」tab，用于本地预览「我的」页样式 */
export const TEST_TAB_HIDDEN = true;

export enum TabType {
  HOME = 'home',
  PROJECT = 'project',
  MINE = 'mine',
  MINE_TEST = 'mine_test',
}

interface BottomTabBarProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

/**
 * 底部导航栏
 */
export const BottomTabBar: React.FC<BottomTabBarProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className="bottom-tab-bar">
      <div
        className={`tab-item ${activeTab === TabType.HOME ? 'active' : ''}`}
        onClick={() => onTabChange(TabType.HOME)}
      >
        <div className="tab-icon">
          <HomeIcon />
        </div>
        <div className="tab-label">首页</div>
      </div>
      <div
        className={`tab-item ${activeTab === TabType.PROJECT ? 'active' : ''}`}
        onClick={() => onTabChange(TabType.PROJECT)}
      >
        <div className="tab-icon">
          <ProjectIcon />
        </div>
        <div className="tab-label">项目</div>
      </div>
      <div
        className={`tab-item ${activeTab === TabType.MINE ? 'active' : ''}`}
        onClick={() => onTabChange(TabType.MINE)}
      >
        <div className="tab-icon">
          <MineIcon />
        </div>
        <div className="tab-label">我的</div>
      </div>
      {!TEST_TAB_HIDDEN && (
        <div
          className={`tab-item ${activeTab === TabType.MINE_TEST ? 'active' : ''}`}
          onClick={() => onTabChange(TabType.MINE_TEST)}
        >
          <div className="tab-icon">
            <TestIcon />
          </div>
          <div className="tab-label">测试</div>
        </div>
      )}
    </div>
  );
};

